import AddButton from "components/shared/AddButton";
import { Input } from "components/shared/FormComponents";
import Loader from "components/shared/Loader";
import SaveChangesButton from "components/shared/SaveChangesButton";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { addSection, editSection, getSection } from "store/actions";

const AddLocation = () => {
  const { loading, error } = useSelector((state) => state.section);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();

  const onSubmit = (data) => {
    data.title = "location";

    dispatch(
      addSection({ page: "locations", data: { section: data }, navigate })
    );
  };

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card">
        <div className="card-head">
          <h4>
            <FormattedMessage id={"add-location"} />
          </h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Col xs={12}>
              <Row>
                <Col sm={6} xs={12}>
                  <Input
                    langId="title"
                    name="locationTitle.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>
                <Col sm={6} xs={12}>
                  <Input
                    langId="title"
                    name="locationTitle.en"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>
              <AddButton />
            </Col>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddLocation;
